import { Row, Col, Space, Modal } from 'antd';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  RadioGroupField,
  InputField,
  DatePickerField,
  ListOptionsField,
  SelectField,
} from '@/components/Form';
import { PROPERTY_TYPE_OPTIONS } from '@/pages/mortgage/routes/Purchase/constant/optionList';
import { OPTIONAL_AGREE_OPTIONS, STATES_OPTIONS } from '@/constant/options';
import { ConveyancingInquirySchema } from '../schema/schema';
import { useState } from 'react';
import { Button, Card } from 'antd';
import { displaySuccess } from '@/utils/displayMessageUtils';
import GoogleCustomLocationField from '@/components/Elements/GoogleCustomLocation';

type ConveyancingInquiryData = yup.InferType<typeof ConveyancingInquirySchema>;

export const ConveyancingInquiry = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(ConveyancingInquirySchema),
  });

  const onSubmit = async (data: ConveyancingInquiryData) => {
    console.log('Form submitted:', data);

    try {
      setIsLoading(true);
      console.log('Feedback api response', data);
      displaySuccess('Inquiry Submitted');
      setIsLoading(false);
      setIsModalOpen(true);
      // reset();
      // setOpen(false);
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      setIsLoading(false);
    }
  };

  const handleModalOk = () => {
    setIsModalOpen(false);
    reset();
  };

  return (
    <>
      <form>
        <Row gutter={12}>
          <Col xs={24} md={24}>
            <SelectField
              label="What is the type of property being purchased?"
              size="large"
              name="propertyType"
              control={control}
              options={PROPERTY_TYPE_OPTIONS}
              error={errors.propertyType?.message?.toString() ?? ''}
            />
            <SelectField
              label="Which state is the property located in?"
              name="propertyLocation"
              control={control}
              options={STATES_OPTIONS}
              size="large"
              error={errors.propertyLocation?.message?.toString() ?? ''}
            />
            <SelectField
              label="When are you planning to settle?"
              name="timeline"
              control={control}
              options={[
                { label: 'Now', value: 'now' },
                { label: 'Within 3 months', value: 'within_3_months' },
                { label: 'Within 6 months', value: 'within_6_months' },
                { label: 'Within 12 months', value: 'within_12_months' },
              ]}
              size="large"
              error={errors.timeline?.message?.toString() ?? ''}
            />
            <GoogleCustomLocationField
              label="Enter Property Address"
              name="propertyAddress"
              control={control}
              placeholder="Enter property address"
              size="large"
              required={true}
              error={errors.propertyAddress?.message?.toString() ?? ''}
            />
          </Col>
        </Row>
        <Space style={{ marginTop: '1rem' }}>
          <Button
            onClick={handleSubmit(onSubmit)}
            type="primary"
            loading={isLoading}
          >
            Get a quote
          </Button>
        </Space>
      </form>
      <Modal
        title="Choose your preferred conveyancer"
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        okText="Close"
        cancelButtonProps={{ style: { display: 'none' } }}
        width={1000}
      >
        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Card>
              <h2>IP House Solicitors</h2>
              <p>Price: AU$2,500 plus GST & Disbursements</p>
              <Space>
                <Button type="primary" size="large">
                  Request introduction
                </Button>
                <Button type="primary" size="large">
                  Pay now
                </Button>
              </Space>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card>
              <h2>Lee & Poon Solicitors</h2>
              <p>Price: AU$1,800 plus GST & Disbursements</p>
              <Space>
                <Button type="primary" size="large">
                  Request introduction
                </Button>
                <Button type="primary" size="large">
                  Pay now
                </Button>
              </Space>
            </Card>
          </Col>
        </Row>
      </Modal>
    </>
  );
};
